import { FormattedMessage } from "react-intl";

import { RanaButton, RanaModal } from "@nens/ranalib";

import { cancelButtonText } from "@/translations";

import { SchematisationsOverview } from "../../../schematisations-overview";
import type { AddToProjectButtonOverride } from "../../../types/add-to-project-button-override";
import { OnImportFromProjectFunc } from "../types/on-import";

export function SchematisationProjectImportModalFromProject({
  onClose,
  isMutating,
  onImport,
}: {
  onClose: () => void;
  isMutating: boolean;
  onImport: OnImportFromProjectFunc;
}) {
  const renderImportButton: AddToProjectButtonOverride = ({ schematisation, revisionId }) => (
    <RanaButton
      isLoading={isMutating}
      onClick={() => onImport({ schematisation, revisionId })}
      variant="primary"
    >
      <FormattedMessage
        id="projectfile.import_existing_model_schema"
        defaultMessage="Import this model schematisation"
      />
    </RanaButton>
  );

  return (
    <RanaModal
      isOpen
      onClose={onClose}
      topBar={
        <FormattedMessage
          id="header.import_schematisation"
          defaultMessage="Import model schematisation to project"
        />
      }
      w="full"
      h="full"
      buttons={[
        {
          children: cancelButtonText,
          variant: "tertiary",
          onClick: onClose,
        },
      ]}
    >
      <SchematisationsOverview
        overwriteAddToProjectButton={renderImportButton}
        disableSettingSearchParams
      />
    </RanaModal>
  );
}
